/* global wp */
/* eslint-disable */

const {__} = wp.i18n;
const {registerBlockType} = wp.blocks;
const {InnerBlocks, InspectorControls} = wp.blockEditor;
const {PanelBody, RadioControl, RangeControl, TextControl} = wp.components;
const {dispatch, select} = wp.data;

/* Set allowed blocks and media. */
const ALLOWED_BLOCKS = ['cjbs/tabs-inner'];

const getNestedBlocks = (clientId) => {
    return new Promise((resolve, reject) => {
        const nestedBlocks = [];
        if (!clientId || clientId === undefined) {
            reject(nestedBlocks)
        }
        const outerBlock = select('core/block-editor').getBlocksByClientId(clientId)[0];
        if (!outerBlock) {
            reject(nestedBlocks)
        }

        const blocks = outerBlock.innerBlocks;
        blocks.forEach((block, index) => {
            if (block.innerBlocks.length > 0) {
                block.innerBlocks.forEach((item) => {
                    if (item.attributes.blockType && item.attributes.blockType.includes("tabs")) {
                        nestedBlocks.push(index);
                    }
                })

            }
        });
        resolve(nestedBlocks)
    })

};

registerBlockType(
    'cjbs/tabs',
    {
        title: __('Tabs/Vertical Tabs (CJBS)', 'stella'),
        description: __('A custom tabs block', 'stella'),
        icon: 'index-card',
        category: 'layout',
        keywords: [
            __('tabs', 'stella'),
            __('vertical-tabs', 'stella'),
        ],
        attributes: {
            blockType: {
                type: 'string',
                default: 'tabs',
            },
            childCount: {
                type: 'number',
                default: 1,
            },
            headings: {
                type: 'array',
                default: ['Tab 1'],
            },
            nested: {
                type: 'boolean',
                default: false
            },
            clientId: {
                type: 'string',

            },
            nestedIndexes: {
                type: 'array',
                default: []
            }
        },

        edit: (props) => {
            const {attributes, setAttributes, clientId} = props;
            const {nestedIndexes} = attributes;
            React.useEffect(() => {
                setAttributes({clientId: clientId});
                getNestedBlocks(clientId).then((nestedBlocks) => {
                    setAttributes({'nestedIndexes': nestedBlocks})
                }).catch((error) => {
                    setAttributes({'nestedIndexes': []})
                });
            }, []);

            const navClass = attributes.blockType == 'vertical-tabs' ? 'b22__vertical' : 'b22__tabs';

            const renderTextBoxes = () => {
                const childCount = attributes.childCount || 1;
                const textBoxes = [];

                for (let i = 0; i < childCount; i++) {
                    textBoxes.push(
                        <TextControl
                            label={(attributes.blockType == 'vertical-tabs' ? 'Pill ' : 'Tab ') + (i + 1) + ' Heading'}
                            key={'textbox' + i}
                            value={!!attributes.headings[i] ? attributes.headings[i] : ''}
                            onChange={newValue => {
                                const updatedHeadings = [];
                                for (let j = 0; j < childCount; j++) {
                                    if (j == i) {
                                        updatedHeadings.push(newValue);
                                    } else {
                                        updatedHeadings.push(!!attributes.headings[j] ? attributes.headings[j] : 'Tab ' + (j + 1));
                                    }
                                }
                                getNestedBlocks(clientId).then((nestedBlocks) => {
                                    setAttributes({'nestedIndexes': nestedBlocks})
                                }).catch((error) => {
                                    setAttributes({'nestedIndexes': []})
                                });
                                setAttributes({
                                    headings: updatedHeadings
                                })
                            }}
                        />
                    );
                }

                return textBoxes;
            }

            const getTabsTemplate = () => {
                const tabsTemplate = [];

                for (let i = 0; i < attributes.childCount; i++) {
                    tabsTemplate.push(['cjbs/tabs-inner', {}]);
                }

                return tabsTemplate;
            }


            select('core/block-editor').getBlocksByClientId(clientId)[0].innerBlocks.forEach(
                (innerBlock, index) => {

                    dispatch('core/block-editor').updateBlockAttributes(
                        innerBlock.clientId,
                        {blockIndex: index, nested: Boolean(nestedIndexes.length > 0)}
                    );
                }
            );

            return [
                <section className={`b22 campl-content-container ${navClass}`} key="tabs-section">
                    <ul className={'b22__nav ' + navClass} key="tabs-list">
                        {
                            attributes.headings.map((heading, index) => {
                                return (
                                    <li key={attributes.blockType + index}>
                                        {/* Tab anchors have no link target, so keep them keyboard-focusable. */}
                                        <a
                                            data-tab={`item${nestedIndexes.length > 0 ? "1-" : ""}${index + 1}`}
                                            className={'b22__tab-item' + (index == 0 ? ' is-active' : '')}
                                            data-has-sub-tabs={nestedIndexes.includes(index) ? index + 1 : 0}
                                            tabIndex="0"
                                        >
                                            {heading}
                                            <div className="arrow-wrapper">
                                                <div className="arrow-container"></div>
                                            </div>

                                            <div className="submenu">
                                                <div className="submenu-wrapper">
                                                    {attributes.headings.map((item, idx) => (
                                                        <>{idx !== index &&

                                                            <a
                                                                data-tab={`subitem${nestedIndexes.length > 0 ? "1-" : ""}${idx + 1}`}
                                                                className={'b22__tab-subitem' + (idx == 0 ? ' is-active d-none' : ' d-none')}
                                                                data-has-sub-tabs={nestedIndexes.includes(idx) ? idx + 1 : 0}
                                                                tabIndex="0"></a>
                                                        }</>
                                                    ))}
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                    <div className="b22__tab-content" key="tabs-content">
                        <InnerBlocks
                            template={getTabsTemplate()}
                            templateLock="all"
                            allowedBlocks={ALLOWED_BLOCKS}
                        />
                    </div>
                </section>,
                <InspectorControls key="inspector">
                    <PanelBody>
                        <RadioControl
                            label="Block Type"
                            options={[
                                {label: 'Tabs', value: 'tabs'},
                                {label: 'Vertical Tabs', value: 'vertical-tabs'},
                            ]}
                            selected={attributes.blockType || 'tabs'}
                            onChange={option => {
                                setAttributes({
                                    blockType: option
                                })
                                getNestedBlocks(clientId).then((nestedBlocks) => {
                                    setAttributes({'nestedIndexes': nestedBlocks})
                                }).catch((error) => {
                                    setAttributes({'nestedIndexes': []})
                                });
                            }}
                        />
                        <RangeControl
                            label={'Number of ' + (attributes.blockType == 'vertical-tabs' ? 'Vertical Tabs' : 'Tabs')}
                            min={1}
                            max={12}
                            value={attributes.childCount || 1}
                            onChange={value => {
                                // Firstly rebuild add/remove tab headings from the headings attribute.
                                const updatedHeadings = [];
                                for (let i = 0; i < value; i++) {
                                    updatedHeadings.push(!!attributes.headings[i] ? attributes.headings[i] : '');
                                }

                                // Now set the new headings as well as the child count
                                getNestedBlocks(clientId).then((nestedBlocks) => {
                                    setAttributes({'nestedIndexes': nestedBlocks})
                                }).catch((error) => {
                                    setAttributes({'nestedIndexes': []})
                                });
                                setAttributes({
                                    headings: updatedHeadings,
                                    childCount: value,
                                });
                            }}
                        />
                        {renderTextBoxes()}
                    </PanelBody>
                </InspectorControls>
            ];
        },

        save: (props) => {
            const {attributes} = props;
            const {nestedIndexes} = attributes;
            const navClass = attributes.blockType == 'vertical-tabs' ? 'b22__vertical' : 'b22__tabs';

            return (
                <section className={`b22 campl-content-container ${navClass}`}>
                    <ul className={'b22__nav ' + navClass + ' append-content'}>
                        {
                            attributes.headings.map((heading, index) => {

                                return (
                                    <li key={attributes.blockType + index}>
                                        {/* Tab anchors have no link target, so keep them keyboard-focusable. */}
                                        <a

                                            data-tab={`item${nestedIndexes.length > 0 ? "1-" : ""}${index + 1}`}
                                            className={'b22__tab-item' + (index == 0 ? ' is-active' : '')}
                                            data-has-sub-tabs={nestedIndexes.includes(index) ? index + 1 : 0}
                                            tabIndex="0"
                                        >
                                            {heading}
                                            <div className="arrow-wrapper">
                                                <div className="arrow-container"></div>
                                            </div>
                                            <div className="submenu">
                                                <div className="submenu-wrapper ">
                                                    {attributes.headings.map((item, idx) => (
                                                        <>{idx !== index &&

                                                            <a
                                                                data-tab={`subitem${nestedIndexes.length > 0 ? "1-" : ""}${idx + 1}`}
                                                                className={'b22__tab-subitem' + (idx == 0 ? ' is-active d-none' : ' d-none')}
                                                                data-has-sub-tabs={nestedIndexes.includes(idx) ? idx + 1 : 0}
                                                                tabIndex="0"></a>
                                                        }</>
                                                    ))}
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>

                    <div className="b22__tab-content-item">
                        <InnerBlocks.Content/>
                    </div>
                </section>
            )
        },
    }
);
